import './SubscriptionLevelTable.scss';
import _ from 'lodash';
import { formatCurrency, isNumber } from 'controls/utils';
import { Header } from 'components/atoms/Header/Header';

// eslint-disable-next-line react/prop-types
export const RolandTable = ({ table, name }) => {
  const headerClass = 'table__header';

  return (
    <div>
      <div className='table'>
        { name && <Header text={name} position='left' fontSize='mediumSize' /> }
        {_.map(table, (e, idx) => (
          <div
            className={`table__data  ${idx === 0 && headerClass}`}
            key={idx}
          >
            {_.map(e, (field, id) => (
              <span
                key={id}
                className={`${
                  idx === 0 ? 'table__header__field' : 'table__data__field'
                }`}
              >
                {field.value === true ? '\u2713' : field.value === false ? '-' : isNumber(field.value) ? formatCurrency(field.value) : field.value}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
